export default __webpack_public_path__ + "static/media/Alert.c6961aea.svg";